/* eslint-disable */
import React, { useEffect, useState } from 'react';
import jwt_decode from "jwt-decode";
import axios from 'axios';
import config from '../../../config/config';
import EditableStatusTable from '../EditableStatusTable/EditableStatusTable ';
import styles from './TemplateApproveComp.module.css';

const { API_BASE_URL } = config;

const TemplateApproveComp = () => {
  const UserToken = keycloak.token;
  let username = '';
  let Email = '';
  if(UserToken !== undefined || UserToken !== null){
    const decoded = jwt_decode(UserToken);
    username = decoded.preferred_username
    Email = decoded.email
  } else{
    console.log("test null..!")
  }
  
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);

  const itemsPerPage = 10;

  const fetchData = async (page = 1) => {
    setLoading(true);
    const token = localStorage.getItem('ApiToken');

    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/template-upload-maker-table`,
        {
          user_id: username,
          pageNumber: page,
          pageSize: itemsPerPage
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // Authorization: 'Basic YWRtaW4xOjEyMw==',
          }
        }
      );
      const resData = response.data;
      setData(resData.data || []);
      setTotalRecords(resData.totalCount || 0);
      // console.log("Fetched page:", page, "Records:", resData.data.length);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData(1);
  }, []);

  const handlePageChange = (page) => {
    fetchData(page);
  };

  const handleCSVDownload = () => {
    alert("Download clicked!");
  };

  const columns = [
    { header: "ID", accessor: "id" },
    { header: "File Name", accessor: "file_name" },
    { header: "Created Date", accessor: "created_date" },
    { header: "Updated Date", accessor: "updated_date" },
    { header: "Status", accessor: "status" },
    { header: "Approved Name", accessor: "approved_name" },
    { header: "Download", accessor: "download" },
  ];
  const downloadURL = '/api/file-upload-maker-download'
  const statuChangeURL = '/api/template-upload-update-status'

  return (
    <div className={styles.filter_panel_container}>
      <h5>Template Status Change</h5>
      <EditableStatusTable
        data={data}
        columns={columns}
        itemsPerPage={itemsPerPage}
        onPageChange={handlePageChange}
        isCustomOpen={true}
        totalRecords={totalRecords}
        handleCSVDownload={handleCSVDownload}
        dataLoading={loading}
        downloadURL={downloadURL}
        statuChangeURL={statuChangeURL}
      />
    </div>
  );
};

export default TemplateApproveComp;